import { BabyGrowthPercentiles } from '~/interfaces'

export const boyWeightPercentiles: BabyGrowthPercentiles = {
  3: [
    2.5, 3.4, 4.4, 5.1, 5.6, 6.1, 6.4, 6.7, 7, 7.2, 7.5, 7.7, 7.8, 8, 8.2, 8.4, 8.5, 8.7, 8.9, 9, 9.2, 9.3, 9.5, 9.7,
    9.8
  ],
  15: [
    2.9, 3.9, 4.9, 5.6, 6.2, 6.7, 7.1, 7.4, 7.7, 7.9, 8.2, 8.4, 8.6, 8.8, 9, 9.2, 9.4, 9.6, 9.7, 9.9, 10.1, 10.3, 10.5,
    10.6, 10.8
  ],
  50: [
    3.3, 4.5, 5.6, 6.4, 7, 7.5, 7.9, 8.3, 8.6, 8.9, 9.2, 9.4, 9.6, 9.9, 10.1, 10.3, 10.5, 10.7, 10.9, 11.1, 11.3, 11.5,
    11.8, 12, 12.2
  ],
  85: [
    3.9, 5.1, 6.3, 7.2, 7.9, 8.4, 8.9, 9.3, 9.6, 10, 10.3, 10.5, 10.8, 11.1, 11.3, 11.6, 11.8, 12, 12.3, 12.5, 12.7, 13,
    13.2, 13.4, 13.7
  ],
  97: [
    4.3, 5.7, 7, 7.9, 8.6, 9.2, 9.7, 10.2, 10.5, 10.9, 11.2, 11.5, 11.8, 12.1, 12.4, 12.7, 12.9, 13.2, 13.5, 13.7, 14,
    14.3, 14.5, 14.8, 15.1
  ]
}

export const boyHeightPercentiles: BabyGrowthPercentiles = {
  3: [
    46.3, 51.1, 54.7, 57.6, 60, 61.9, 63.6, 65.1, 66.5, 67.7, 69, 70.2, 71.3, 72.4, 73.4, 74.4, 75.4, 76.3, 77.2, 78.1,
    78.9, 79.7, 80.5, 81.3, 82.1
  ],
  15: [
    47.9, 52.7, 56.4, 59.3, 61.7, 63.7, 65.4, 66.9, 68.3, 69.6, 70.9, 72.1, 73.3, 74.4, 75.5, 76.5, 77.5, 78.5, 79.5,
    80.4, 81.3, 82.2, 83, 83.8, 84.6
  ],
  50: [
    49.9, 54.7, 58.4, 61.4, 63.9, 65.9, 67.6, 69.2, 70.6, 72, 73.3, 74.5, 75.7, 76.9, 78, 79.1, 80.2, 81.2, 82.3, 83.2,
    84.2, 85.1, 86, 86.9, 87.8
  ],
  85: [
    51.8, 56.7, 60.5, 63.5, 66, 68.1, 69.8, 71.4, 72.9, 74.3, 75.6, 77, 78.2, 79.4, 80.6, 81.8, 82.9, 84, 85.1, 86.1,
    87.1, 88.1, 89.1, 90, 91
  ],
  97: [
    53.4, 58.4, 62.2, 65.3, 67.8, 69.9, 71.6, 73.2, 74.7, 76.2, 77.6, 78.9, 80.2, 81.5, 82.7, 83.9, 85.1, 86.2, 87.3,
    88.4, 89.5, 90.5, 91.6, 92.6, 93.6
  ]
}

export const boyHeadCircumferencePercentiles: BabyGrowthPercentiles = {
  3: [
    32.1, 35.1, 36.9, 38.3, 39.4, 40.3, 41, 41.7, 42.2, 42.6, 43, 43.4, 43.6, 43.9, 44.1, 44.3, 44.5, 44.7, 44.9, 45,
    45.2, 45.3, 45.4, 45.6, 45.7
  ],
  15: [
    33.1, 36.1, 37.9, 39.3, 40.4, 41.3, 42.1, 42.7, 43.2, 43.7, 44.1, 44.4, 44.7, 45, 45.2, 45.5, 45.6, 45.8, 46, 46.2,
    46.3, 46.4, 46.6, 46.7, 46.8
  ],
  50: [
    34.5, 37.3, 39.1, 40.5, 41.6, 42.6, 43.3, 44, 44.5, 45, 45.4, 45.8, 46.1, 46.3, 46.6, 46.8, 47, 47.2, 47.4, 47.5,
    47.7, 47.8, 48, 48.1, 48.3
  ],
  85: [
    35.8, 38.5, 40.3, 41.7, 42.9, 43.8, 44.6, 45.3, 45.8, 46.3, 46.7, 47.1, 47.4, 47.7, 47.9, 48.2, 48.4, 48.6, 48.7,
    48.9, 49.1, 49.2, 49.4, 49.5, 49.7
  ],
  97: [
    36.9, 39.5, 41.3, 42.7, 43.9, 44.8, 45.6, 46.3, 46.9, 47.4, 47.8, 48.2, 48.5, 48.8, 49, 49.3, 49.5, 49.7, 49.9, 50,
    50.2, 50.4, 50.5, 50.7, 50.8
  ]
}

export const girlWeightPercentiles: BabyGrowthPercentiles = {
  3: [
    2.4, 3.2, 4, 4.6, 5.1, 5.5, 5.8, 6.1, 6.3, 6.6, 6.8, 7, 7.1, 7.3, 7.5, 7.7, 7.8, 8, 8.2, 8.3, 8.5, 8.7, 8.8, 9, 9.2
  ],
  15: [
    2.8, 3.6, 4.5, 5.1, 5.6, 6.1, 6.4, 6.7, 7, 7.3, 7.5, 7.7, 7.9, 8.1, 8.3, 8.5, 8.7, 8.8, 9, 9.2, 9.4, 9.6, 9.8, 9.9,
    10.1
  ],
  50: [
    3.2, 4.2, 5.1, 5.8, 6.4, 6.9, 7.3, 7.6, 7.9, 8.2, 8.5, 8.7, 8.9, 9.2, 9.4, 9.6, 9.8, 10, 10.2, 10.4, 10.6, 10.9,
    11.1, 11.3, 11.5
  ],
  85: [
    3.7, 4.8, 5.9, 6.7, 7.3, 7.8, 8.3, 8.7, 9, 9.3, 9.6, 9.9, 10.2, 10.4, 10.7, 10.9, 11.2, 11.4, 11.6, 11.9, 12.1,
    12.4, 12.6, 12.8, 13.1
  ],
  97: [
    4.2, 5.4, 6.5, 7.4, 8.1, 8.7, 9.2, 9.6, 10, 10.4, 10.7, 11, 11.3, 11.6, 11.9, 12.2, 12.5, 12.7, 13, 13.3, 13.5,
    13.8, 14.1, 14.3, 14.6
  ]
}

export const girlHeightPercentiles: BabyGrowthPercentiles = {
  3: [
    45.6, 50, 53.2, 55.8, 58, 59.9, 61.5, 62.9, 64.3, 65.6, 66.8, 68, 69.2, 70.3, 71.3, 72.4, 73.3, 74.3, 75.2, 76.2,
    77, 77.9, 78.7, 79.6, 80.3
  ],
  15: [
    47.2, 51.7, 55, 57.6, 59.8, 61.7, 63.4, 64.9, 66.3, 67.6, 68.9, 70.2, 71.3, 72.5, 73.6, 74.7, 75.7, 76.7, 77.7,
    78.7, 79.6, 80.5, 81.4, 82.2, 83.1
  ],
  50: [
    49.1, 53.7, 57.1, 59.8, 62.1, 64, 65.7, 67.3, 68.7, 70.1, 71.5, 72.8, 74, 75.2, 76.4, 77.5, 78.6, 79.7, 80.7, 81.7,
    82.7, 83.7, 84.6, 85.5, 86.4
  ],
  85: [
    51.1, 55.7, 59.2, 62, 64.3, 66.3, 68.1, 69.7, 71.2, 72.6, 74, 75.4, 76.7, 77.9, 79.2, 80.3, 81.5, 82.6, 83.7, 84.8,
    85.8, 86.8, 87.8, 88.8, 89.8
  ],
  97: [
    52.7, 57.4, 60.9, 63.8, 66.2, 68.2, 70, 71.6, 73.2, 74.7, 76.1, 77.5, 78.9, 80.2, 81.4, 82.7, 83.9, 85, 86.2, 87.3,
    88.4, 89.4, 90.5, 91.5, 92.5
  ]
}

export const girlHeadCircumferencePercentiles: BabyGrowthPercentiles = {
  3: [
    31.7, 34.3, 36, 37.2, 38.2, 39, 39.7, 40.4, 40.9, 41.3, 41.7, 42, 42.3, 42.6, 42.9, 43.1, 43.3, 43.5, 43.6, 43.8,
    44, 44.1, 44.3, 44.4, 44.6
  ],
  15: [
    32.7, 35.3, 37, 38.2, 39.3, 40.1, 40.8, 41.5, 42, 42.4, 42.8, 43.2, 43.5, 43.8, 44, 44.2, 44.4, 44.6, 44.8, 45,
    45.1, 45.3, 45.4, 45.6, 45.7
  ],
  50: [
    33.9, 36.5, 38.3, 39.5, 40.6, 41.5, 42.2, 42.8, 43.4, 43.8, 44.2, 44.6, 44.9, 45.2, 45.4, 45.7, 45.9, 46.1, 46.2,
    46.4, 46.6, 46.7, 46.9, 47, 47.2
  ],
  85: [
    35.1, 37.8, 39.5, 40.8, 41.9, 42.8, 43.5, 44.2, 44.7, 45.2, 45.6, 46, 46.3, 46.6, 46.8, 47.1, 47.3, 47.5, 47.7,
    47.8, 48, 48.2, 48.3, 48.5, 48.6
  ],
  97: [
    36.1, 38.8, 40.5, 41.9, 43, 43.9, 44.6, 45.3, 45.9, 46.3, 46.8, 47.1, 47.5, 47.7, 48, 48.2, 48.5, 48.7, 48.8, 49,
    49.2, 49.4, 49.5, 49.7, 49.8
  ]
}
